import { Component, NgModule } from '@angular/core';
import { CardAuthModule, CreatePasswordFormModule } from 'src/app/components';

@Component({
	selector: 'app-create-password-form',
	templateUrl: './create-password-form.component.html',
	styleUrls: ['./create-password-form.component.scss']
})
export class AppCreatePasswordComponent {

	defaultLink = '/sign-in-form';

	buttonLink = '/create-password-form';

	constructor() { }
}

@NgModule({
	imports: [
		CardAuthModule,
		CreatePasswordFormModule,
	],
	providers: [],
	exports: [AppCreatePasswordComponent],
	declarations: [AppCreatePasswordComponent],
})
export class AppCreatePasswordModule { }

